export default __webpack_public_path__ + "static/media/live_active.73ed4878.png";